export default __webpack_public_path__ + "static/media/CouponUpload.765e7c68.xlsx";